import api from '../../../services/api'

export const getCurrentMember = () => api.get('/members/me')
export const updateCurrentMember = (payload) => api.patch('/members/me', payload)
export const checkCurrentMemberNickname = (targetNickname) => api.get(
  '/members/me/check-nickname',
  { params: { targetNickname } },
)
export const getWithdrawalReasons = () => api.get('/members/me/withdrawal-reasons')
export const withdrawCurrentMember = (withdrawReason) => api.post(
  '/members/me/withdraw',
  { withdrawReason },
)
